import { isReadOnlySelector } from 'modules/MedComms/selectors';
import { createStructuredSelector } from 'reselect';
import * as appSelectors from 'containers/App/selectors';
import { projectFlatColors } from 'containers/BrandDefinition/selectors';
import { documents, projectMetadataTokenExistanceBySectionId } from 'containers/Documents/selectors';
import { layouts, orderedActiveLayoutIds } from 'containers/Layouts/selectors';
import { documentIdsAreBeingUploaded, isOpenToolbar, projectType } from 'containers/Project/selectors';
import { relationsByRegularLayoutId } from 'containers/Relations/selectors';

export const sectionSelector = createStructuredSelector({
  activeLayoutIds: appSelectors.activeLayoutIds,
  allLayouts: layouts,
  artboardLayoutIds: orderedActiveLayoutIds,
  colors: projectFlatColors,
  documentIdsAreBeingUploaded,
  documents,
  dragHotspotGroupLayoutId: appSelectors.dragHotspotGroupLayoutId,
  dragHotspotPosition: appSelectors.dragHotspotPosition,
  projectMetadataTokenExistanceBySectionId,
  moveableLayoutId: appSelectors.moveableLayoutId,
  projectType,
  relationsByRegularLayoutId,
  ssiHotspotPosition: appSelectors.ssiHotspotPosition,
  isReadOnly: isReadOnlySelector,
  isOpenToolbar,
  isResizingColumn: appSelectors.isResizingColumn,
  isResizingLayout: appSelectors.isResizingLayout,
  isResizingRow: appSelectors.isResizingRow,
  dragSourceType: appSelectors.dragSourceType,
  isDraggingAsset: appSelectors.isDraggingAsset,
});
